import { createRouter, createWebHistory } from 'vue-router';
import { routes } from '@/pages';
import middlewarePipeline from '@/app/middleware/middleware-pipeline';
import { nativeApp } from '@/shared/services/native-app';

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Если есть сохраненная позиция прокрутки, восстанавливаем её
    if (savedPosition) {
      return savedPosition;
    } else {
      // В противном случае, скроллим в верхнюю часть страницы
      return { top: 0 };
    }
  },
});

router.onError((error, to) => {
  // @ts-ignore
  if (error.message.includes('Failed to fetch dynamically imported module')) window.location = to.fullPath;
});

router.beforeEach((to, from, next) => {
  nativeApp.navigate(to.path);
  if (!to.meta.middleware) return next();

  const middleware = to.meta.middleware;
  const context = {
    to,
    from,
    next,
  };

  // @ts-ignore
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1),
  });
});

export { router };
